import { REHYDRATE } from 'redux-persist';
import { rehydrateReducerState, createPersistedState, updateState, createState } from 'ngx-myia-redux';
import { IAuthState } from 'ngx-myia-http'
import { AUTH_COMPLETED, AUTH_FAILED, AUTH_LOG_OUT, AUTH_REFRESH_COMPLETED, AUTH_REFRESH_FAILED, AUTH_REFRESH_STARTED, AUTH_STARTED } from './authActions';

export const authReducerKey = 'auth';

const initialState = createPersistedState<IAuthState>(
    {
        _isLoading: false,
        hasError: false,
        isAuth: false,
        clientId: null,
        token: null,
        refreshToken: null,
    });

export function authReducer(state = initialState, action: any) {
    switch (action.type) {
        case REHYDRATE:
            return rehydrateReducerState(authReducerKey, state, action);
        case AUTH_STARTED:
            return updateState(state, (newState: IAuthState) => {
                newState._isLoading = true; // '_' prefix is used to avoid property persistence
                newState.hasError = false;
                newState.isAuth = false;
                newState.email = action.email;
                newState.token = null;
                newState.refreshToken = null;
            });
        case AUTH_COMPLETED:
            return updateState(state, (newState: IAuthState) => {
                newState._isLoading = false; // '_' prefix is used to avoid property persistence
                newState.hasError = false;
                newState.isAuth = true;
                newState.clientId = action.clientId;
                newState.email = action.email;
                newState.token = action.token;
                newState.refreshToken = action.refreshToken;
            });
        case AUTH_FAILED:
            return updateState(state, (newState: IAuthState) => {
                newState._isLoading = false; // '_' prefix is used to avoid property persistence
                newState.hasError = true;
                newState.isAuth = false;
                newState.email = action.email;
                newState.token = null;
                newState.refreshToken = null;
                newState.clientId = null;
            });
        case AUTH_REFRESH_STARTED:
            return updateState(state, (newState: IAuthState) => {
                newState._isLoading = true; // '_' prefix is used to avoid property persistence
                newState.hasError = false;
                newState.isAuth = false;
                newState.email = action.email;
                newState.token = null;
                newState.refreshToken = null;
            });
        case AUTH_REFRESH_COMPLETED:
            return updateState(state, (newState: IAuthState) => {
                newState._isLoading = false; // '_' prefix is used to avoid property persistence
                newState.hasError = false;
                newState.isAuth = true;
                newState.email = action.email;
                newState.token = action.token;
                newState.refreshToken = action.refreshToken;
            });
        case AUTH_REFRESH_FAILED:
            return updateState(state, (newState: IAuthState) => {
                newState._isLoading = false; // '_' prefix is used to avoid property persistence
                newState.hasError = true;
                newState.isAuth = false;
                newState.email = action.email;
                newState.token = null;
                newState.refreshToken = null;
                newState.clientId = null;
            });
        case AUTH_LOG_OUT:
            return createState<IAuthState>(
                {
                    _isLoading: false,
                    hasError: false,
                    isAuth: false,
                    clientId: null,
                    token: null,
                    refreshToken: null,
                });
        default:
            return state;
    }
}

/** Reducer object (name: reducer function) */
export default {
    [authReducerKey]: authReducer
};
